import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Tag} from 'antd'

class TagItem extends Component {
    _handleDisplayTagOrder = () => {
        const {tag} = this.props
        let tagOrder = '';
        if(tag === 'gift'){ 
            tagOrder = 'Hàng tặng';
        }else if(tag === 'sample'){
            tagOrder = 'Hàng mẫu';
        }else if(tag === 'fba' || tag === 'FBA'){
            tagOrder = 'FBA';
        }else if(tag === 'fastship'){
            tagOrder = 'Ship nhanh';
        }else if(tag === 'UIDSAMPLE'){
            tagOrder = 'UIDSAMPLE';
        }else if(tag === 'fastproduction'){
            tagOrder = 'Sản xuất nhanh'
        }else if(tag === 'cutoff'){
            tagOrder = 'cutoff'
        }else if(tag === 'cutoff_noel'){
            tagOrder = 'cutoff_noel'
        }else if(tag === 'cutoff_new_year'){
            tagOrder = 'cutoff_new_year'
        }else if(tag === 'tiktok'){
            tagOrder = 'TIKTOK'
        }else if(tag === '24h'){
            tagOrder = '24h'
        }else if(tag === 'SLL'){
            tagOrder = 'SLL'
        }else if(tag === 'rnd_test'){
            tagOrder = tag
        }else if(tag === 'Dlican'){
            tagOrder = tag
        }else if(tag === 'force_cmyk'){
            tagOrder = tag
        }else if(tag === 'test_color'){
            tagOrder = tag
        }
        
        if(tagOrder){
            if(tagOrder === 'Sản xuất nhanh'){
                return <div><Tag color='#FFA500'>{tagOrder}</Tag></div>
            }else if(tagOrder === 'cutoff'){
                return <div><Tag color='#FF6600'>{tagOrder}</Tag></div> 
            }else if(tagOrder === 'cutoff_noel'){
                return <div><Tag color='#FF6600'>{tagOrder}</Tag></div>
            }else if(tagOrder === 'cutoff_new_year'){
                return <div><Tag color='#FF6600'>{tagOrder}</Tag></div>
            }else if(['TIKTOK', '24h', 'Dlican', 'force_cmyk'].includes(tagOrder)){
                return <div><Tag color='#dc3644'>{tagOrder}</Tag></div> 
            }else if(tagOrder === 'SLL'){
                return <div><Tag color='#fdb813'>{tagOrder}</Tag></div> 
            }else if(tagOrder === 'RND'){
                return <div><Tag color='#6c757d'>{tagOrder}</Tag></div> 
            }else{
                return <div><Tag color='#6c757d'>{tagOrder}</Tag></div>
            }
            
        }
    }

    render() {
        return (
            <>
                {
                    this._handleDisplayTagOrder()
                }
            </>
        )
    }
}

TagItem.propTypes = {
    tag: PropTypes.string
}

export default TagItem
